import { render } from "./CompanyTabOverview.vue?vue&type=template&id=e990dc30"
import script from "./CompanyTabOverview.vue?vue&type=script&lang=js"
export * from "./CompanyTabOverview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__